// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
// Utilities
import { flexParent, flexParentCenterAll } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * makeStyles hook for PlanIcon component
 */ export const usePlanIconStyles = makeStyles({
    dynamicIcon: {
        ...flexParent(),
        ...flexParentCenterAll,
        borderRadius: tokens.borderRadiusMedium,
        "& .fui-Avatar__icon": {
            backgroundColor: tokens.colorTransparentBackground,
            color: tokens.colorNeutralForeground2,
            "& svg": {
                width: "100%",
                height: "100%",
                "& path": {
                    transform: "scale(1.07)",
                    transformOrigin: "center"
                }
            }
        }
    }
});
